import React, { useEffect, useState } from 'react';
import { request } from './services/token';
import WebSocketService from './services/websocket';
import ThermalWebSocketService from './services/thermalWebsocket';
import App from './App';

async function init() {
  const { jwt, gh_token: ghToken } = await request() || {};

  if (ghToken && window.ipc && typeof window.ipc.send === 'function') {
    window.ipc.send('checkForUpdates', ghToken);
    window.ipc.on('log', (event, message) => {
      let log = [];
      try {
        log = JSON.parse(sessionStorage.getItem('log')) || [];
      } catch {
        // ignore
      }
      log.push(message);
      sessionStorage.setItem('log', JSON.stringify(log));
      window.ipc.send('logStored', log);
    });
  }

  const wss = new WebSocketService();
  await wss.connect(jwt, ghToken);

  const tWss = new ThermalWebSocketService();
  await tWss.connect();

  return { wss, tWss };
}

const AppLoader = () => {
  const [webSocketService, setWebSocketService] = useState();
  const [thermalWebSocketService, setThermalWebSocketService] = useState();

  useEffect(() => {
    init().then(({ wss, tWss }) => {
      setWebSocketService(wss);
      setThermalWebSocketService(tWss);
    });
  }, []);

  return (
    <App
      webSocketService={webSocketService}
      thermalWebsocketService={thermalWebSocketService}
    />
  );
};

export default AppLoader;
